import React__default from 'react';
import { useDroppable } from '@dnd-kit/core';
import { DroppableRegionValue } from '../../types.mjs';
import styles from './DroppableRegion.scss.mjs';

function DroppableRegion() {
  const {
    active,
    setNodeRef: setFullExpandRegionNodeRef
  } = useDroppable({
    id: DroppableRegionValue.FullExpand
  });
  const {
    setNodeRef: setCollapseRegionNodeRef
  } = useDroppable({
    id: DroppableRegionValue.Collapse
  });
  const {
    setNodeRef: setHalfExpandRegionNodeRef
  } = useDroppable({
    id: DroppableRegionValue.MidExpand
  });
  if (!active) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.Droppable
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.DroppableInterior
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: setFullExpandRegionNodeRef,
    className: styles.DroppableTop
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: setHalfExpandRegionNodeRef,
    className: styles.DroppableMid
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: setCollapseRegionNodeRef,
    className: styles.DroppableBottom
  })));
}

export { DroppableRegion };
